import { computed } from 'vue'
import { useRouteState } from './useRouteState'

export function useEntityRoute() {
  const { params , query, updateQuery} = useRouteState()

  const entityType = computed(() => params.value.type)
  const authentication_code = computed(() => query.value.code)
  const listViewTargetId = computed(() => query.value.edit) 
  const passwordExpired = computed(() => query.value.passwordExpired)
  const ssoState = computed(() => query.value.state)
  const authlink= computed(() => query.value.authlink)
  const SecretCode= computed(() => query.value.SecretCode)
  const accessToken= computed(() => query.value.accessToken)
  const redirectSubsystem= computed(() => query.value.redirectSubsystem)
  const landingPath= computed(() => query.value.landingPath)
  const USER_ID_FOR_SRP= computed(() => query.value.USER_ID_FOR_SRP)
  const challengeName= computed(() => query.value.challengeName)
  const session= computed(() => query.value.session)

  const updateListViewTargetId = (id) => {
    updateQuery({ edit: id })
  }

  const removePasswordPrompt = () => {
    updateQuery({ passwordExpired: "false" })
  }

  return {
    entityType,
    authentication_code,
    listViewTargetId,
    updateListViewTargetId,
    passwordExpired,
    removePasswordPrompt,
    ssoState,
    authlink,
    SecretCode,
    accessToken,
    redirectSubsystem,
    landingPath,
    USER_ID_FOR_SRP,
    challengeName,
    session
  }
}
